import React, { useState } from "react";
import styled from "styled-components";

interface AnimatedTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
}

const TextareaWrapper = styled.div`
  position: relative;
  margin-top: 20px;
`;

const TextareaField = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 10px;
  resize: vertical;
  appearance: none;
  border: solid 1px rgb(220, 220, 220);
  box-sizing: border-box;
  flex: 1 1 auto;
  font-size: 14px;
  display: block;
  outline: none;
  background-color: transparent;

  &::placeholder {
    color: transparent;
    transition: all 0.3s ease-in-out;
    transform-origin: top left;
    font-size: 14px;
  }

  &:focus {
    &::placeholder {
      transform: translateY(-150%) scale(0.8);
      color: #999;
    }
  }
`;

const Label = styled.label<{ focused: boolean; hasValue: boolean }>`
  position: absolute;
  top: ${({ focused, hasValue }) => (focused || hasValue ? "-15px" : "10px")};
  left: ${({ focused, hasValue }) => (focused || hasValue ? "-1px" : "10px")};
  font-size: ${({ focused, hasValue }) => (focused || hasValue ? "12px" : "14px")};
  color: ${({ focused, hasValue }) => (focused || hasValue ? "#999" : "#605F5F")};
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  user-select: none;
  font-family: 'Fira Sans', sans-serif;
`;

const AnimatedTextarea: React.FC<AnimatedTextareaProps> = ({ label, ...props }) => {
  const [focused, setFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.target;
    setHasValue(value.length > 0);
    props.onChange && props.onChange(event);
  };

  return (
    <TextareaWrapper>
      <Label htmlFor={props.id || props.name} focused={focused} hasValue={hasValue}>
        {label}
      </Label>
      <TextareaField {...props} onFocus={handleFocus} onBlur={handleBlur} onChange={handleChange} />
    </TextareaWrapper>
  );
};

export default AnimatedTextarea;
